





























import { BackButton,FloatingFooter, InputBox, LoadingButton, NavigationBar } from "@goodless/components"
import { NetworkManager } from "@goodless/networking";
import { ErrorBox, GeneralErrorsView } from "@simonbackx/simple-error-forms";
import { NavigationMixin } from "@simonbackx/vue-app-navigation";
import { Component, Mixins } from "vue-property-decorator";

@Component({
    components: {
        InputBox,
        GeneralErrorsView,
        LoadingButton,
        FloatingFooter,
        NavigationBar,
        BackButton
    },
})
export default class ForgotPasswordView extends Mixins(NavigationMixin) {
    errorBox: ErrorBox | null = null
    email = ""
    loading = false

    async submit() {
        if (this.loading) {
            return
        }
        this.loading = true
        this.errorBox = null

        try {
            await NetworkManager.server.request({
                method: "POST",
                path: "/auth/forgot-password",
                body: {
                    email: this.email
                },
            })
            this.pop({ force: true })
            alert(this.$t('forgotPassword.confirmationMessage').toString())
        } catch (e) {
            this.errorBox = new ErrorBox(e)
        }
        this.loading = false
    }
    
}
